export default __webpack_public_path__ + "static/media/tartaleta-chocolate-blanco.49db04af.jpg";